export const TICKET_FIELD_NAME = 'fetchTicketForHelpdesk';